<div class="reviews-container">
    <div nz-row class="review-menu-section" *ngIf="reviewsWrapper.length">
        <div nz-col nzSpan="8">
            <nz-card class="section-card">
                <nz-checkbox-group [(ngModel)]="filterUserTypeOptions" (ngModelChange)="filterByUserType()"></nz-checkbox-group>
            </nz-card>
        </div>
        <div nz-col nzSpan="16">
            <nz-card class="section-card">
                <div class="review-menu-section-right">
                    <div class="left">
                        <label nz-checkbox [(ngModel)]="onlyReviews">Only Reviews</label>
                    </div>
                    <div class="right">
                        <div class="menu-control-wrapper" (click)="sortByReviewDate()">
                            <span>Date</span>
                            <leap-sort-caret [active]="true" [direction]="1"></leap-sort-caret>
                        </div>
                        <!--TODO implement helpful action-->
<!--                        <div class="menu-control-wrapper" (click)="sortByRating()">-->
<!--                            <span>Most Helpful</span>-->
<!--                            <leap-sort-caret [active]="true" [direction]="this.sortByRatingASC ? 1 : -1"></leap-sort-caret>-->
<!--                        </div>-->
                    </div>
                </div>
            </nz-card>
        </div>
    </div>
    <div nz-row class="review-items-section">
        <leap-review-item *ngFor="let item of reviewsWrapper"
                          [avatar]="null"
                          [reviewText]="item.review.message"
                          [rating]="item.review.rating"
                          [reviewerName]="item.review.user?.firstName"
                          [isBuyer]="item.review.user?.account.buyer"
                          [isSeller]="item.review.user?.account.seller"
                          [isInstructor]="item.review.user?.account.instructor"
                          [visible]="item.visible">
        </leap-review-item>
    </div>
    <div nz-row *ngIf="!reviewsWrapper.length">
        <nz-card>
            No reviews available for this product.
        </nz-card>
    </div>
</div>

